import { helper as buildHelper } from "@ember/component/helper"
import moment from "moment"

export function dateRange(params /*, hash*/) {
  var startDate = moment(params[0])
  var endDate = moment(params[1])

  var startMonth = startDate.format("MMMM")
  var endMonth = endDate.format("MMMM")

  if (startDate.format("MMMM D") === endDate.format("MMMM D")) {
    return startDate.format("MMMM D")
  } else if (startMonth === endMonth) {
    return startDate.format("MMM. D") + " - " + endDate.format("D")
  } else {
    return startDate.format("MMM. D") + " - " + endDate.format("MMM. D")
  }

  return params
}

export default buildHelper(dateRange)
